// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"o8-z"};